export function ProgressColors() {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-blue-500 text-white"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-red-500 text-white"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-green-500 text-white"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-amber-500 text-black"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-teal-500 text-white"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-indigo-500 text-white"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-purple-500 text-white"></div>
      </div>
      <div className="flex-start flex h-2.5 w-full overflow-hidden rounded-full bg-blue-gray-50 font-sans text-xs font-medium">
        <div className="flex h-full w-1/2 items-center justify-center overflow-hidden break-all rounded-full bg-pink-500 text-white"></div>
      </div>
    </div>
  );
}
